export default __webpack_public_path__ + "static/media/0040.0ccb1ec3.png";